import React, { useState } from 'react'
import { Button, CollapsibleHeader, FormGrid, FormGroup, Input, Label, Select, Separator, Summary, SummaryItem, SummaryLabel, SummaryValue, Title } from '../../style'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { OrderType } from '../..'

interface DetailsSectionProps {
  order: OrderType
  setOrder: React.Dispatch<React.SetStateAction<OrderType>>
}

const DetailsSection: React.FC<DetailsSectionProps> = ({ order, setOrder }) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(true)
  
  const formData = {
    orderTypes: [{ name: "Venda" }],
    paymentTerms: [{ name: "12x sem juros no boleto" }],
    shippingTypes: [{ name: "Transportes S/A" }],
    trackingCodes: [{ name: "AG987654321BR" }],
    attachments: [{ name: "Pedido_1.docx" }],
  }

  const summaryData = {
    quantity: "450",
    taxes: "12,3%",
    total: "R$ 24.456,89",
  }
  
  const handleChange = (field: keyof OrderType) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setOrder(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }

  return(
    <>
      <CollapsibleHeader onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
        <Title>Detalhes do pedido</Title>
        <Button>
          {isDetailsOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </Button>
      </CollapsibleHeader>

      {isDetailsOpen && (
        <>
          <FormGrid style={{ marginTop: '16px' }}>
            <FormGroup>
              <Label>Tipo de pedido</Label>
              <Select value={order.orderType} onChange={handleChange('orderType')}>
                <option value="">Selecione</option>
                {formData.orderTypes.map(type => (
                  <option key={type.name} value={type.name}>{type.name}</option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Data do pedido</Label>
              <Input 
                type='date' 
                value={order.orderDate} 
                onChange={handleChange('orderDate')}
              />
            </FormGroup>

            <FormGroup>
              <Label>Prazo de entrega</Label>
              <Input 
                type='date' 
                value={order.deliveryDate} 
                onChange={handleChange('deliveryDate')}
              />
            </FormGroup>
          </FormGrid>

          <FormGrid>
            <FormGroup>
              <Label>Condição de pagamento</Label>
              <Select value={order.paymentTerm} onChange={handleChange('paymentTerm')}>
                <option value="">Selecione</option>
                {formData.paymentTerms.map(term => (
                  <option key={term.name} value={term.name}>{term.name}</option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Tipo de frete</Label>
              <Select value={order.shippingType} onChange={handleChange('shippingType')}>
                <option value="">Selecione</option>
                {formData.shippingTypes.map(type => (
                  <option key={type.name} value={type.name}>{type.name}</option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Valor do frete</Label>
              <Input 
                value={order.shippingValue} 
                onChange={handleChange('shippingValue')}
              />
            </FormGroup>
          </FormGrid>

          <FormGrid>
            <FormGroup>
              <Label>Código de rastreio</Label>
              <Input 
                value={order.trackingCode} 
                onChange={handleChange('trackingCode')}
              />
            </FormGroup>

            <FormGroup>
              <Label>Informação extra</Label>
              <Input 
                value={order.extraInfo} 
                onChange={handleChange('extraInfo')}
              />
            </FormGroup>
          </FormGrid>
        </>
      )}
      <Separator />
      <Summary>
        <SummaryItem>
          <SummaryLabel>Quantidade de peças:</SummaryLabel>
          <SummaryValue>{order.totalQuantity || 0}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Tributos:</SummaryLabel>
          <SummaryValue>{order.taxes || 0}%</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Total:</SummaryLabel>
          <SummaryValue>R$ {order.total || 0}</SummaryValue>
        </SummaryItem>
      </Summary>
    </>
  )
}

export default DetailsSection